import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

function signInSuccess(draft: Draft<IAuthData>) {
  draft.config.isLoading = false;
}

export default signInSuccess;
